<template>
	<div class="home-currency-list">
		<header class="fade-in-bottom-small">
			<span class="theme-color">Web3</span>
			journey starts from here!
		</header>
		<div class="cm-tabs-group">
			<span class="cm-tab active-btn-bg">{{ $t('数字货币') }}</span>
		</div>
		<div class="list" v-for="item in data" :key="item.id">
			<div class="teb-i dasdas">
				<img :src="item.image" class="asda">
				<div class="ml5">
					{{ item.symbol }} /
					<span style="color: rgb(125, 139, 153);">
						<span>{{ item.currency }}</span>
					</span>
				</div>
			</div>
			<div class="teb-i teb-i2 fsfs">${{ item.price }}</div>
			<div class="teb-i dwsdw fsfs">
				<span :class="item.price_zf > 0 ? 'green' : 'red'">{{ item.price_zf > 0 ? '+' + item.price_zf :
					item.price_zf }}%</span>
			</div>
			<div class="teb-i teb-i2 fsfs">{{ item.trade_amount }}</div>
			<div class="line">
				<echartsMode :chartData="item.kline" :colorS="item.price_zf > 0 ? '#00f0ff' : '#ff4834'"></echartsMode>
			</div>
		</div>
		<button class="cm-btn-animation1" @click="$nav.go('/pc/quotes')">
			<span>{{ $t('查看更多') }}</span>
			<img src="@/assets/img-pc/33.5a9cc0e8.svg">
		</button>
	</div>
</template>
<script>
import echartsMode from './model4Line.vue';
export default {
	props: {
		data: {
			type: Array,
			default: () => [],
		},
	},
	components: {
		echartsMode
	},
	data() {
		return {
		};
	},
	methods: {
	},
};
</script>
<style lang="scss" scoped>
.home-currency-list {
	position: relative;
	margin: 0 auto 90px;

	.list {
		height: 80px;
		display: flex;
		flex-wrap: nowrap;
		flex-direction: row;
		align-items: center;
		justify-content: normal;
		padding: 0 30px;
		font-size: 18px;
		cursor: pointer;
		background: #0d0e0f;
		margin-bottom: 20px;
		border-radius: 18px;

		.teb-i {
			flex: 1;
			font-weight: 400;
			color: #fff;

			.asda {
				width: 40px;
				height: 40px;
				margin-right: 10px;
				border-radius: 50%;
			}
		}

		.line {
			flex: none;
			width: 90px;
			height: 34px;
		}

		.dasdas {
			display: flex;
			align-items: center;
		}

		.green {
			color: #00f0ff !important;
		}

		.red {
			color: #ff4834 !important;
		}

		p {
			margin: 0px;
		}
	}

	.cm-tabs-group {
		padding: 5px;
		border-radius: 100px;
		border: 1px solid #333;
		border-radius: 50px;
		width: 100%;
		margin: 0 auto 0;
		justify-content: space-between;
		margin-bottom: 20px;

		position: relative;
		color: #fff;
		display: flex;
		flex-direction: row;
		align-items: center;

		.cm-tab {
			font-size: 18px;
			width: 165px;
			height: 46px;
			flex-wrap: nowrap;
			justify-content: center;
			line-height: 1 !important;
			cursor: pointer;
			border-radius: 100px;
			z-index: 10;
			position: relative;
			color: #fff;
			display: flex;
			flex-direction: row;
			align-items: center;

			&.active-btn-bg {
				background: linear-gradient(90deg, #00e3ff, #089);
			}
		}
	}
}

.fade-in-bottom-small {
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 50px;
	line-height: 60px;
	margin-bottom: 60px;

	.theme-color {
		color: #00f0ff !important;
	}
}

.cm-btn-animation1 {
	position: relative;
	display: flex;
	justify-content: center;
	align-items: center;
	min-width: 200px;
	height: 44px;
	padding: 14px 60px;
	border: 1px solid #333;
	background-color: #000;
	color: #fff;
	font-size: 18px;
	border-radius: 24px;
	margin: 20px auto 0;
	cursor: pointer;
	overflow: hidden;
	min-width: 268px;
	margin: 20px auto 0;

	img {
		transition: all .2s;
		margin-left: 15px;
	}
}
</style>